import React, { useEffect, useState } from "react";
import ReactStrapTable from "components/reactStrapTable";
import { cellRendererCheck } from "utils/columns";
import Drawer from "components/Drawer";

import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Nav,
  NavItem,
  Button,
} from "reactstrap";
import ErrorBoundary from "components/ErrorBoundary";

import TopDrugclassPMPMDrawer from "pages/ClientDashBoard/Components/GridData/GridReports/TopDrugClassPMPMDrawer";
const DrugClassByPMPM = ({ drugClassPMPM, dateRange, planId, groupId, startDate,endDate,rebatechecked ,planCode,groupCode}) => {
  const [disabledViewButtom, setDisabledViewButtom] = useState(true);
   const [isOpen, setIsOpen] = useState(false);
  const currencyFormat = (value) => {
    if (!value || isNaN(value)) return "-";
    if (value < 0)
      return (
        <span className="text-danger text-end">
          {"-$" +
            (value * -1).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
    else
      return (
        <span className="text-end">
          {"$" + value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
        </span>
      );
  };
useEffect(() => {
  if (drugClassPMPM && drugClassPMPM.length > 0) {
    setDisabledViewButtom(false);
  } else {
    setDisabledViewButtom(true);
  }
}, [drugClassPMPM]);

  const Columns = [
    {
      dataField: "drugName",
      text: "Drug Class",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) =>
        cellRendererCheck(row.drugName),
    },
    {
      dataField: "pmpm",
      text: "PMPM",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (drugClassPMPM) => currencyFormat(drugClassPMPM.pmpm),
    },
  ];

  const handleProceed = () => {
    setIsOpen(!isOpen);
  };
   const onHandleIsOpen = (hasRefresh)=> {
     
        if (isBoolean(hasRefresh) && hasRefresh) {
            onClose(true);
        }
        setIsOpen(!isOpen)
      }

  return (
    <ErrorBoundary>
    <Card className="p-3 h-100">
      <CardHeader className="border-0 bg-white px-0 pt-0">
        <Row className="align-items-center">
          <Col>
            <CardTitle className="f-20 font-weight-500">
              Top 10 Drug Classes - By Spend PMPM
            </CardTitle>
          </Col>
        </Row>
      </CardHeader>

      <CardBody className="dashboard-chart-body">
        <div
          className={`table-card scroll-table position-relative border-0 rounded pt-0 scroll ${
            drugClassPMPM?.length > 0 ? "fixed-height" : "default"
          }`}
        >
          <ReactStrapTable columns={Columns} data={drugClassPMPM || []} />
        </div>
        <div className="view-report">
          <Button
            color="primary"
            className="ms-2"
            onClick={handleProceed}
            style={{ float: "right", marginTop: "26px" }}
            disabled={disabledViewButtom}
          >
            View Report
          </Button>
        </div>
      </CardBody>
    </Card>
      <Drawer
                direction='end'
                title='Top 10 Drug Classes - By Spend PMPM'
                isOpen={isOpen}
                toggle={handleProceed}
                size="lg"
            >
                    <TopDrugclassPMPMDrawer  dateRange={dateRange} planId={planId} groupId={groupId} startDate={startDate} endDate={endDate} planCode={planCode} groupCode={groupCode} rebatechecked={rebatechecked} onHandleIsOpen={onHandleIsOpen} />
            </Drawer> 
    </ErrorBoundary>
  );
};

export default DrugClassByPMPM;
